import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const boardsDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'boards-directory-redirect',
	path: '/secure/ManageRapidViews.jspa',
};
